"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var GraphQLErrorFunctions_1 = require("../../error/functions/GraphQLErrorFunctions");
var LinkCellFormatter_1 = require("../datagrid/cellFormatters/LinkCellFormatter");
var ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
var SortableHeaderFormatter_1 = require("../datagrid/headerFormatters/SortableHeaderFormatter");
var TypedDataGridInterfaces_1 = require("../datagrid/TypedDataGridInterfaces");
var ExplorerStyledDisplayGrid_1 = require("./ExplorerStyledDisplayGrid");
var shouldBeObfuscated = function (_a) {
    var name = _a.name;
    return name === null;
};
function getRowDataForDashboard(dashboard) {
    return {
        id: dashboard.id,
        name: dashboard.name,
        path: dashboard.path,
        workbookName: dashboard.workbook ? dashboard.workbook.name : null,
        workbookVizportalUrlId: dashboard.workbook ? dashboard.workbook.vizportalUrlId : null,
        projectName: dashboard.workbook ? dashboard.workbook.projectName : null,
        projectVizportalUrlId: dashboard.workbook ? dashboard.workbook.projectVizportalUrlId : null,
        ownerName: dashboard.workbook ? dashboard.workbook.owner.name : null,
        ownerUsername: dashboard.workbook ? dashboard.workbook.owner.username : null,
        ownerDomain: dashboard.workbook ? dashboard.workbook.owner.domain : null,
    };
}
exports.getRowDataForDashboard = getRowDataForDashboard;
var columns = [
    function (sortParams) { return ({
        name: 'name',
        dataKey: globalTypes_1.DashboardOrderField.NAME,
        headerText: Localize_1.Messages.GridHeaderName(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedLinkOrTextCellFormatter(shouldBeObfuscated, function (_a) {
            var name = _a.name;
            return name;
        }, function (urls, _a) {
            var path = _a.path;
            return path ? urls.viewPath(path) : null;
        }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'workbook',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderWorkbook(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedLinkOrTextCellFormatter(function (_a) {
            var workbookName = _a.workbookName;
            return workbookName === null;
        }, function (_a) {
            var workbookName = _a.workbookName;
            return workbookName;
        }, function (urls, _a) {
            var workbookVizportalUrlId = _a.workbookVizportalUrlId;
            return workbookVizportalUrlId ? urls.workbookLineagePath(workbookVizportalUrlId) : null;
        }),
        resizable: true,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'project',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderProject(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: LinkCellFormatter_1.createLinkOrTextCellFormatter(function (_a) {
            var projectName = _a.projectName;
            return projectName || '';
        }, function (urls, _a) {
            var projectVizportalUrlId = _a.projectVizportalUrlId;
            return projectVizportalUrlId ? urls.projectPath(projectVizportalUrlId) : null;
        }),
        resizable: true,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'owner',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.Owner(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: LinkCellFormatter_1.createLinkCellFormatter(
        // If ownerName, ownerUsername, and ownerDomain are null, there is likely a permission denied issue
        function (_a) {
            var ownerName = _a.ownerName, ownerUsername = _a.ownerUsername;
            return ownerName || ownerUsername || '';
        }, function (urls, _a) {
            var ownerUsername = _a.ownerUsername, ownerDomain = _a.ownerDomain;
            if (ownerUsername && ownerDomain) {
                return urls.userPath(ownerUsername, ownerDomain);
            }
            else {
                return '';
            }
        }),
        resizable: true,
        sortable: false,
    }); }
];
function DashboardsDisplayGrid(props) {
    var cols = columns.map(function (columnFactory) { return columnFactory(props); });
    return (React.createElement(ExplorerStyledDisplayGrid_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: GraphQLErrorFunctions_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.DashboardsDisplayGrid = DashboardsDisplayGrid;
//# sourceMappingURL=DashboardsDisplayGrid.js.map